module.exports = __webpack_public_path__ + "static/media/stats-ontime.becabbfc.png";